import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
} from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import { ReactComponent as OkIcon } from '../../../../../assets/img/icon/Ok.svg';
import WhatsappSrc from '../../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../../assets/img/whatsapp.png';
import FloatingButton from '../../../../../components/FloatingButton';
import SharedDialog from '../../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../../config/app';
import { ANSWER } from '../../../../../constants/website.constant';
import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { useEndorsementsDataContext } from '../../../../../context/endorsements/endorsements.provider';
import { useVehiclesContext } from '../../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';
import { useTipification } from '../../../../../hooks/useTipification';
import { sumInsuredQuotation } from '../../../../../services/policy/policy.service';

const SumAssured = () => {
  const { vehicle } = useVehiclesContext();
  const { nextStep, updateEndorsementBody, endorsement_body, setLoaderHelper } =
    useEndorsementsDataContext();

  const [sumInsuredQuote, setSumInsuredQuote] = useState<any>();
  const [sumAssuredInfo, setSumAssuredInfo] = useState(
    endorsement_body.sumInsuredData
  );
  const [hasQuotation, setHasQuotation] = useState(false);
  const [open, setOpen] = useState(false);
  const [openErrors, setOpenErrors] = useState(false);
  const [element, setElement] = useState<any>('default');
  const history = useHistory();
  const { user } = useAuthDataContext();
  const { trackEvent, events } = useTipification();

  const handleContinue = () => {
    endorsement_body?.sumInsuredData?.finalQuotation < sumInsuredQuote
      ? trackEvent(events.ENDORSEMENT_UPGRADE, `${sumInsuredQuote}`)
      : trackEvent(events.ENDORSEMENT_DOWNGRADE, `${sumInsuredQuote}`);
    updateEndorsementBody({
      sumInsuredData: { ...sumAssuredInfo, finalQuotation: sumInsuredQuote },
    });
    dataLayerPush('modificar_poliza_modsuma_continuar', user?.id);
    setOpen(true);
  };

  const addSumAssured = () => {
    const addResult =
      sumAssuredInfo?.totalsum + sumAssuredInfo?.increment_range;

    if (
      sumAssuredInfo?.initialValue !== sumAssuredInfo?.minimum_rate &&
      sumAssuredInfo?.totalsum === sumAssuredInfo?.minimum_rate
    ) {
      setSumAssuredInfo((prevState) => ({
        ...prevState,
        lastTotalAmount: prevState.totalsum,
        totalsum: sumAssuredInfo.lastTotalAmount,
      }));
    } else {
      setSumAssuredInfo((prevState) => ({
        ...prevState,
        lastTotalAmount: prevState.totalsum,
        totalsum:
          addResult > sumAssuredInfo?.maximum_rate
            ? sumAssuredInfo?.maximum_rate
            : addResult,
      }));
    }

    setHasQuotation(false);
  };

  const reduceSumAssured = () => {
    const reduceResult =
      sumAssuredInfo?.totalsum - sumAssuredInfo?.increment_range;

    if (
      sumAssuredInfo?.initialValue !== sumAssuredInfo?.maximum_rate &&
      sumAssuredInfo?.totalsum === sumAssuredInfo?.maximum_rate
    ) {
      setSumAssuredInfo((prevState) => ({
        ...prevState,
        lastTotalAmount: prevState?.totalsum,
        totalsum: sumAssuredInfo.lastTotalAmount,
      }));
    } else {
      setSumAssuredInfo((prevState) => ({
        ...prevState,
        lastTotalAmount: prevState?.totalsum,
        totalsum:
          reduceResult < sumAssuredInfo?.minimum_rate
            ? sumAssuredInfo?.minimum_rate
            : reduceResult,
      }));
    }

    setHasQuotation(false);
  };

  // Modal Content
  const getContent = (modalCasesInfo) => {
    if (modalCasesInfo.businessLogicErrorAfinnity) {
      //case afinnity
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            Por favor comunicate con nosotros por Whatsapp de Lunes a Viernes de
            9 a 18 Hs., para procesar el cambio.
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.businessLogicErrorCompanyProducer) {
      // companyProducer
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            !Lo sentimos! El cambio no puede procesarse. Por favor comunicate
            con tu productor / asesor para procesar el cambio.
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.RC_afinnity) {
      // RC_affinity
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Para modificar tu suma asegurada.
          </Typography>
          <Typography>
            Por favor comunicate con nosotros por Whatsapp de lunes a viernes de
            09 a 18 Hs. para poder gestionar tu pedido.
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.RC_Company_Producer) {
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Para modificar tu suma asegurada
          </Typography>
          <Typography>
            Por favor comunicate con tu productor/asesor para poder gestionar tu
            pedido
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.retryModal) {
      // GW no responde
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            ¡Lo sentimos! El cambio no puede procesarse. Te pedimos que
            reintentes en otro momento.
          </Typography>
        </Box>
      );
    } else {
      // GW no responde default
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            ¡Lo sentimos! El cambio no puede procesarse. Te pedimos que
            reintentes en otro momento.
          </Typography>
        </Box>
      );
    }
  };

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  // Modal Actions
  const getActions = () => {
    //affinity o RC_affinity van con whatsapp
    return (
      <Grid container>
        <Grid item xs={12} sm={12}>
          <Box m={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={redirectHome}
            >
              Entendido
            </Button>
          </Box>
        </Grid>
        {ANSWER && (
          <Grid item xs={12} sm={12}>
            <Box m={2}>
              <Link
                href={appConfig?.WHATSAPP_LINK}
                rel="noopener"
                target="_blank"
              >
                <Button variant="outlined" fullWidth color="secondary">
                  <Box m={1}>
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px', marginRight: '15px' }}
                    />
                  </Box>
                  <Typography display="inline">
                    Comunicarme vía Whatsapp
                  </Typography>
                </Button>
              </Link>
            </Box>
          </Grid>
        )}
      </Grid>
    );
  };

  const generateQuotation = async () => {
    let quotationError: any = {};

    dataLayerPush('modificar_poliza_modsuma_cotizar', user?.id);
    setLoaderHelper(true);

    await sumInsuredQuotation(
      vehicle.policy.id,
      sumAssuredInfo?.jobNumber,
      vehicle.id,
      sumAssuredInfo?.totalsum
    )
      .then((quotationData) => {
        if (
          quotationData?.data?.data &&
          quotationData?.data?.data?.cost &&
          quotationData?.data?.data?.cost[0]
        ) {
          setLoaderHelper(false);
          setSumInsuredQuote(quotationData.data);
          setHasQuotation(true);
        } else {
          quotationError = {
            ...quotationData.data,
            http_code: quotationData.status,
          };
        }
      })
      .catch((err) => {
        setLoaderHelper(false);
        // ver que trae el catch con errores 400
        quotationError = {
          ...err.response.data,
          http_code: err.response.status,
        };
      });

    if (quotationError && quotationError?.http_code) {
      let modalCases = {
        businessLogicErrorAfinnity:
          quotationError.http_code === 406 &&
          quotationError.code === 101 &&
          endorsement_body.policyInfo[0]?.provider?.grouped_company !== 'sura',

        businessLogicErrorCompanyProducer:
          quotationError.http_code === 406 &&
          quotationError.code === 101 &&
          endorsement_body.policyInfo[0]?.provider?.grouped_company === 'sura',

        RC_afinnity:
          quotationError.http_code === 409 &&
          endorsement_body.policyInfo[0]?.provider?.grouped_company !== 'sura',

        RC_Company_Producer:
          quotationError.http_code === 409 &&
          endorsement_body.policyInfo[0]?.provider?.grouped_company === 'sura',

        retryModal:
          quotationError.http_code === 400 && quotationError.code === 110,
      };

      setElement(getContent(modalCases));
      setHasQuotation(false);
      setLoaderHelper(false);
      setOpenErrors(true);
    }
  };

  return (
    <>
      {!!Object.keys(vehicle).length && (
        <>
          <SharedDialog
            open={openErrors}
            onClose={() => setOpenErrors(false)}
            content={<Box>{element}</Box>}
            actions={getActions()}
          ></SharedDialog>

          <SharedDialog
            open={open}
            content={
              <Box>
                <Typography
                  variant="h6"
                  style={{ marginTop: '5px', marginBottom: '-15px' }}
                >
                  Este cambio posee un costo adicional.
                </Typography>
              </Box>
            }
            onClose={() => setOpen(false)}
            actions={
              <Grid container>
                <Grid item xs={12} sm={12}>
                  <Box m={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => nextStep()}
                    >
                      Entendido
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            }
          ></SharedDialog>

          <Grid container justify="center">
            <Grid item xs={11} sm={10} lg={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Box my={3}>
                    <Typography
                      variant="h6"
                      color="primary"
                      style={{ marginBottom: '35px' }}
                    >
                      Modificar suma
                    </Typography>
                  </Box>
                </Grid>

                <Grid container justify="center">
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    <Box style={{ alignItems: 'center' }}>
                      <Typography variant="caption">
                        Suma asegurada (con costo adicional)
                      </Typography>

                      <Box
                        style={{
                          display: 'flex',
                          borderRadius: '5px',
                          flexWrap: 'nowrap',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: '8px',
                        }}
                      >
                        <IconButton
                          onClick={() => reduceSumAssured()}
                          color="secondary"
                          disabled={
                            sumAssuredInfo?.totalsum ===
                            sumAssuredInfo?.minimum_rate
                          }
                        >
                          <RemoveIcon />
                        </IconButton>

                        <TextField
                          size="small"
                          fullWidth={true}
                          variant="outlined"
                          value={sumAssuredInfo ? sumAssuredInfo.totalsum : 0}
                          InputProps={{
                            readOnly: true,
                          }}
                        />

                        <IconButton
                          color="secondary"
                          onClick={() => addSumAssured()}
                          disabled={
                            sumAssuredInfo?.totalsum ===
                            sumAssuredInfo?.maximum_rate
                          }
                        >
                          <AddIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                  {!hasQuotation && (
                    <Grid item xs={12}>
                      {sumAssuredInfo.totalsum ===
                        sumAssuredInfo.initialValue && (
                        <Grid item xs={12}>
                          <Divider
                            style={{
                              marginTop: '10px',
                            }}
                          ></Divider>

                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            flexWrap="wrap"
                            marginTop="5px"
                            color="#0033A0"
                          >
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              flexWrap="wrap"
                            >
                              <Typography variant="caption">
                                Esta es tu suma asegurada actual
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      )}
                      <Box mt={2}>
                        <Typography variant="subtitle1" color="primary">
                          Tené en cuenta:
                        </Typography>
                      </Box>
                      <List aria-label="detalles">
                        <ListItem>
                          <ListItemIcon>
                            <OkIcon />
                          </ListItemIcon>
                          <ListItemText
                            disableTypography
                            primary={
                              <Typography variant="body2">
                                La suma asegurada es el precio de mercado del
                                vehículo que aseguraste.
                              </Typography>
                            }
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <OkIcon />
                          </ListItemIcon>
                          <ListItemText
                            disableTypography
                            primary={
                              <Typography variant="body2">
                                Podés aumentarla o disminuirla con un tope
                                máximo, acorde al valor del riego en el mercado.
                              </Typography>
                            }
                          />
                        </ListItem>
                        <ListItem>
                          <ListItemIcon>
                            <OkIcon />
                          </ListItemIcon>
                          <ListItemText
                            disableTypography
                            primary={
                              <Typography variant="body2">
                                La modificación de tu suma asegurada, puede
                                generar una variación en el costo de tu seguro.
                              </Typography>
                            }
                          />
                        </ListItem>
                      </List>
                    </Grid>
                  )}
                </Grid>

                {hasQuotation && (
                  <Grid item xs={12}>
                    <Grid item xs={12}>
                      <Divider
                        style={{
                          marginTop: '20px',
                          backgroundColor: 'black',
                        }}
                      ></Divider>
                    </Grid>

                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexWrap="wrap"
                      marginTop="20px"
                      color="#0033A0"
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        flexWrap="wrap"
                      >
                        <Typography>COSTO</Typography>
                      </Box>

                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        flexWrap="wrap"
                      >
                        <Typography>
                          $
                          {sumInsuredQuote
                            ? sumInsuredQuote.data?.cost[0].total
                            : ''}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid container justify="center">
            <Grid item xs={12} sm={6}>
              <Box>
                {hasQuotation ? (
                  <Box>
                    <FloatingButton
                      variant="contained"
                      color="secondary"
                      fullWidth
                      onClick={handleContinue}
                      style={{ marginBottom: '25px' }}
                    >
                      Continuar
                    </FloatingButton>
                  </Box>
                ) : (
                  <Box>
                    <FloatingButton
                      variant="contained"
                      color="secondary"
                      fullWidth
                      onClick={generateQuotation}
                      disabled={
                        sumAssuredInfo?.initialValue ===
                        sumAssuredInfo?.totalsum
                      }
                      style={{ marginBottom: '25px' }}
                    >
                      Cotizar
                    </FloatingButton>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default SumAssured;
